/**
 * モーダルコンポーネント
 * - ModalContainer: モーダル表示トリガー
 * - ModalBox: モーダルボックス本体
 */

class ModalContainer extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('modal-show a');
    const stopsellingCont = this.querySelector('.stopselling-cont');
    if (link) {
      link.addEventListener('click', this.onClickLink.bind(this));
    } else if (stopsellingCont) {
      this.renderModalBox(true);
    }
  }

  onClickLink(event) {
    event.preventDefault();
    this.renderModalBox();
  }

  renderModalBox(construct = false) {
    const modalBox = document.getElementById('ModalBox');
    modalBox.querySelector('.modal__container').classList.add('show-modal');
    modalBox.querySelector('.modal-content').innerHTML = this.querySelector('modal-content').innerHTML;
    if (!construct) {
      modalBox.bindCloseBtn();
    }

    document.body.style.overflowY = 'hidden';
  }
}

customElements.define('modal-container', ModalContainer);

class ModalBox extends HTMLElement {
  constructor() {
    super();
    this.bindCloseBtn();
  }

  bindCloseBtn() {
    const elements = this.querySelectorAll('.close-modal');
    elements.forEach(element => {
      element.addEventListener('click', this.onClickBtn.bind(this));
    });
  }

  onClickBtn(event) {
    event.preventDefault();
    this.querySelector('.modal__container').classList.remove('show-modal');
    document.body.style.overflowY = 'inherit';
  }
}

customElements.define('modal-box', ModalBox);
